<template lang="pug">
  div
    filter-table(
      layout="text"
      @inputSearchFilter="inputSearchFilter")
    .credits-table.ods-mt-6
      ods-table(
        v-loading="loadingTable"
        style='width: 100%'
        :data='tableDataRendered'
        :default-sort="{prop: 'cod', order: 'descending'}"
        )
        ods-table-column(prop='codterm' label='Código de terminal' sortable)
        ods-table-column(prop='desterm' label='Tipo' sortable)
        ods-table-column(prop='desindsit' label='Estado' sortable class-name="cell-tag")
          template(slot-scope="scope")
            ods-tag(:type="getType(scope.row.indsittpv)") {{ scope.row.desindsit }}
        ods-table-column(prop='fecinstpv' label='Fecha instalación' sortable)
          template(slot-scope="scope")
            div {{ scope.row.fecinstpv | formatDateLocale }}
        ods-table-column(prop='fecalta' label='Fecha alta' sortable)
          template(slot-scope="scope")
            div {{ scope.row.fecalta | formatDateLocale }}
        ods-table-column(prop='fecbaja' label='Fecha baja' sortable)
          template(slot-scope="scope")
            div {{ scope.row.fecbaja | formatDateLocale }}
        ods-table-column(prop='acciones' label='acciones' align="center" class-name="cell-actions")
          template(slot-scope="scope")
            //- ods-tooltip(content="Ver terminal")
            ods-button(type="text" icon="ods-icon-eye" @click.prevent="goToDetailTerminal(scope.row)")

      div.footer
        paginator(
          :isNextPage="indMasDatos"
          :currentPage="currentPage"
          @buttonPrevAction="getPrevPage"
          @buttonNextAction="getNextPage")
        //- div.footer__texPage {{ this.$t('commerceInfo.terminalsInquiries') }} : {{ tableData2.length }}
        //- ods-pagination.footer__page(
        //- :page-sizes = '[5, 10, 50, 100]',
        //- :page-size = itemsPerPage,
        //- layout='prev, pager, next',
        //- :total='totalData'
        //- @size-change='handleSizeChange',
        //- @current-change='handleCurrentChange'
        //- style="text-align: right; margin-top: 20px")

    el-drawer(
      :title="vendorTitle"
      :visible.sync="showDetailPage"
      direction="rtl",
      :wrapperClosable="false"
      :append-to-body="false"
      size="60%"
      :class="vendorFormType")
      ods-scrollbar(viewClass="view-class" wrapClass="wrap-class")

        terminal-detail(:data="terminalInfo")

</template>

<script>
import { mapGetters } from 'vuex'
import FilterTable from '@/components/shared/FilterTable'
import Paginator from '@/components/shared/Paginator'
import TerminalDetail from '@/components/CommerceInfo/TerminalDetail'

export default {
  name: 'TerminalsInquiriesTable',

  components: {
    FilterTable,
    Paginator,
    TerminalDetail
  },

  props: {
    // data: {
    //   required: true
    // },
    comercio: {
      required: true
    }
  },

  data () {
    return {
      defaultParams: { codcom: this.comercio.codcom },
      paginationParams: null,
      tableData: null,
      tableDataRendered: null,
      currentPage: null,
      indMasDatos: null,
      loadingTable: false,
      // el-drawer
      vendorFormType: '',
      vendorTitle: '',
      showDetailPage: false,
      terminalInfo: {}
      // tableData: this.data,
      // provisional hasta tener datos del servicio
      // tableData2: [{
      //   cod: '001',
      //   class: 'QR',
      //   qr: true,
      //   type: 'Virtual',
      //   descriptionType: 'Virtual',
      //   displaced: false,
      //   model: '1504',
      //   description: 'Virtual',
      //   codCICS: null,
      //   highDate: {
      //     anno: 2021,
      //     dia: 10,
      //     format: 'dd-MM-yyyy',
      //     mes: 11,
      //     nombreDia: 'viernes',
      //     nombreMes: 'octubre',
      //     type: 'ax2269:EaseDate',
      //     valueDate: '08-10-2021'
      //   },
      //   lowDate: {
      //     anno: 2021,
      //     dia: 3,
      //     format: 'dd-MM-yyyy',
      //     mes: 12,
      //     nombreDia: 'viernes',
      //     nombreMes: 'octubre',
      //     type: 'ax2269:EaseDate',
      //     valueDate: '08-10-2021'
      //   },
      //   lowMotive: '00-No hay baja',
      //   situation: '10-TPV Operativo',
      //   instalationDate: {
      //     anno: 2021,
      //     dia: 7,
      //     format: 'dd-MM-yyyy',
      //     mes: 11,
      //     nombreDia: 'viernes',
      //     nombreMes: 'octubre',
      //     type: 'ax2269:EaseDate',
      //     valueDate: '08-10-2021'
      //   },
      //   lastOperationDate: {
      //     anno: 2021,
      //     dia: 8,
      //     format: 'dd-MM-yyyy',
      //     mes: 9,
      //     nombreDia: 'viernes',
      //     nombreMes: 'octubre',
      //     type: 'ax2269:EaseDate',
      //     valueDate: '08-10-2021'
      //   },
      //   owner: '0',
      //   tpvManagement: 'E-Entidad',
      //   tpvSesion: '0',
      //   observations: 'Aquí irían las observaciones necesarias (en caso de que las haya).',
      //   id: 0,
      //   estado: 'Pendiente'
      // }, {
      //   cod: '0012',
      //   class: 'QR',
      //   qr: true,
      //   type: 'Físico',
      //   descriptionType: 'Físico',
      //   displaced: false,
      //   model: '1504',
      //   description: 'Físico',
      //   codCICS: null,
      //   highDate: {
      //     anno: 2021,
      //     dia: 29,
      //     format: 'dd-MM-yyyy',
      //     mes: 10,
      //     nombreDia: 'viernes',
      //     nombreMes: 'octubre',
      //     type: 'ax2269:EaseDate',
      //     valueDate: '08-10-2021'
      //   },
      //   lowDate: {
      //     anno: 2021,
      //     dia: 21,
      //     format: 'dd-MM-yyyy',
      //     mes: 3,
      //     nombreDia: 'viernes',
      //     nombreMes: 'octubre',
      //     type: 'ax2269:EaseDate',
      //     valueDate: '08-10-2021'
      //   },
      //   lowMotive: '00-No hay baja',
      //   situation: '10-TPV Operativo',
      //   instalationDate: {
      //     anno: 2021,
      //     dia: 4,
      //     format: 'dd-MM-yyyy',
      //     mes: 12,
      //     nombreDia: 'viernes',
      //     nombreMes: 'octubre',
      //     type: 'ax2269:EaseDate',
      //     valueDate: '08-10-2021'
      //   },
      //   lastOperationDate: {
      //     anno: 2021,
      //     dia: 8,
      //     format: 'dd-MM-yyyy',
      //     mes: 11,
      //     nombreDia: 'viernes',
      //     nombreMes: 'octubre',
      //     type: 'ax2269:EaseDate',
      //     valueDate: '08-10-2021'
      //   },
      //   owner: '0',
      //   tpvManagement: 'E-Entidad',
      //   tpvSesion: '0',
      //   observations: 'Aquí irían las observaciones necesarias (en caso de que las haya).',
      //   id: 1,
      //   estado: 'Abonado'
      // }],
      // currentPageData: 1,
      // totalData: 0
    }
  },

  computed: {
    ...mapGetters([
      // 'itemsPerPage'
    ])
  },

  watch: {
  //   data (newData, oldData) {
  //     this.tableData = newData
  //     this.totalData = newData.length
  //     this.handlePagination()
  //   }
  },

  methods: {
    async getData (params) {
      this.loadingTable = true
      // Listado de Consultas - Terminales
      await this.$store.dispatch('listVisorTPVS', params)
        .then((res) => {
          this.loadingTable = false
          if (res.registros) {
            this.tableData = Array.isArray(res.registros) ? res.registros : [res.registros]
            this.tableDataRendered = this.tableData
          } else {
            this.tableData = null
            this.tableDataRendered = this.tableData
          }
          this.currentPage = res.pantPagina
          this.indMasDatos = res.indMasDatos
          this.paginationParams = {
            claveInicio: res.claveInicio,
            claveFin: res.claveFin
          }
        })
    },

    getInitialData () {
      const params = {
        ...this.defaultParams
      }
      this.getData(params)
    },

    getPrevPage () {
      const params = {
        ...this.defaultParams,
        ...this.paginationParams,
        retroceder: true
      }
      this.getData(params)
    },

    getNextPage () {
      const params = {
        ...this.defaultParams,
        ...this.paginationParams,
        avanzar: true
      }
      this.getData(params)
    },

    inputSearchFilter (text) {
      this.tableDataRendered = this.tableData.filter((res) => {
        return res.desterm.toLowerCase().includes(text.toLowerCase()) ||
          res.desindsit.toLowerCase().includes(text.toLowerCase()) ||
          res.codterm.toString().toLowerCase().includes(text.toString().replace(',', '.').toLowerCase())
      })
    },

    // handleSizeChange (val) {
    //   this.itemsPerPage = val
    //   this.handlePagination()
    // },

    // handleCurrentChange (val) {
    //   this.currentPageData = val
    //   this.handlePagination()
    // },

    // handlePagination (arr) {
    //   if (Array.isArray(this.data)) {
    //     this.tableData = this.data.slice(
    //       (this.currentPageData - 1) * this.itemsPerPage,
    //       this.currentPageData * this.itemsPerPage)
    //   }
    // },

    getType (row) {
      switch (row) {
        case '00':
          return 'warning'
        case 10:
          return 'success'
        case 20:
        case 30:
          return 'danger'
      }
    },

    goToDetailTerminal (row) {
      // this.$emit('openDetailTerminal', row)
      this.terminalInfo = row
      this.formToDisplay = 'terminalDetail'
      this.vendorFormType = 'add'
      this.showDetailPage = true
      this.vendorTitle = 'Detalle Terminal'
    }
  },

  mounted () {
    this.getInitialData()
    // if (Array.isArray(this.data)) this.totalData = this.data.length
    // this.handlePagination()
  }
}
</script>

<style lang="scss" scoped>
.notfound {
  margin-top: rem(28)
}

/deep/ .ods-table__row {
  cursor: pointer;
}
</style>
